import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const nudgeSecurity = defineConnector({
  identifier: "nudgeSecurity",
  name: "Nudge Security",
  tagLine: "SaaS security and governance",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.nudgesecurity\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log into [Nudge Security](https://app.nudgesecurity.com). Navigate to **Settings** > **API Tokens** and click **Create API Token**.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "Your Nudge Security API token. Tokens expire after four weeks of inactivity.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.nudgesecurity.io/api/1.0/apps",
  },
});
